module.exports = __webpack_public_path__ + "static/media/avatar.581e7f89.png";